var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI FLOW PRO Dashboard",
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-872 -881)",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 2",
    filter: "url(#filter0_d_1_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -546,
    y: -691,
    width: 611,
    height: 756,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -546,
    y: -691,
    width: 611,
    height: 756,
    rx: 10,
    stroke: "#EBEBFD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 135"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -525.5,
    y: -12.5,
    width: 570,
    height: 57,
    rx: 7.5,
    stroke: "#EBEBFD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#51307F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1923 8.90487C15.4066 8.69065 15.6973 8.57031 16.0003 8.57031C16.3033 8.57031 16.594 8.69065 16.8083 8.90487L21.9513 14.0479C22.1573 14.2638 22.2707 14.5518 22.2672 14.8503C22.2637 15.1488 22.1436 15.434 21.9325 15.6451C21.7215 15.8562 21.4362 15.9763 21.1377 15.9798C20.8393 15.9833 20.5513 15.8699 20.3353 15.6639L17.1433 12.4719V22.2849C17.1433 22.588 17.0229 22.8787 16.8085 23.0931C16.5942 23.3074 16.3034 23.4279 16.0003 23.4279C15.6972 23.4279 15.4064 23.3074 15.1921 23.0931C14.9777 22.8787 14.8573 22.588 14.8573 22.2849V12.4719L11.6653 15.6639C11.5601 15.7741 11.434 15.8622 11.2943 15.923C11.1545 15.9838 11.0041 16.016 10.8517 16.0178C10.6994 16.0196 10.5482 15.9909 10.4071 15.9334C10.266 15.8759 10.1378 15.7908 10.0301 15.6831C9.92235 15.5753 9.83724 15.4472 9.77977 15.3061C9.72229 15.1649 9.6936 15.0138 9.69539 14.8614C9.69718 14.7091 9.72941 14.5586 9.79019 14.4189C9.85097 14.2792 9.93906 14.153 10.0493 14.0479L15.1923 8.90487Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 11",
    filter: "url(#filter1_d_1_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: -691,
    width: 427,
    height: 756,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: -691,
    width: 427,
    height: 756,
    rx: 10,
    stroke: "#EBEBFD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_6",
    x: -626.5,
    y: -741.5,
    width: 772,
    height: 917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_6",
    x: 14.5,
    y: -741.5,
    width: 588,
    height: 917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0 0.861344 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-872 -881)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2c3d9dd211f28a1c306e57ac847ae4be.svg";
export { ForwardRef as ReactComponent };